import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Button from "./Button";
import styles from "./CheckboxButton.module.scss";
export default function CheckboxButton(_a) {
    var { checked, className, children } = _a, props = __rest(_a, ["checked", "className", "children"]);
    return (_jsx(Button, Object.assign({ className: styles.checkboxButton }, props, { children: _jsx("div", Object.assign({ className: "label" }, { children: children })) })));
}
